"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WeightPerLengthUnitSchema = void 0;
const zod_1 = require("zod");
exports.WeightPerLengthUnitSchema = zod_1.z.enum(['kg_km', 'kg_m', 'g_m', 'lbs_mft', 'lbs_ft']);
exports.default = exports.WeightPerLengthUnitSchema;
//# sourceMappingURL=WeightPerLengthUnitSchema.js.map